import { useGlobalContext } from "@/context/GlobalContext";
import { apiClient } from "@/services/apiServices";
import axios from "axios";
import { useEffect, useState } from "react";

// Country-to-Currency mapping
const countryToCurrency: { [key: string]: string } = {
  IN: "INR", // India
  US: "USD", // USA
  CA: "USD", // CANADA FOR testing added inr
  DE: "EUR", // Germany
  FR: "EUR", // France
  GB: "GBP", // UK
  IT: "EUR", // Italy
  ES: "EUR", // Spain
  NL: "EUR", // Netherlands
  BE: "EUR", // Belgium
  AT: "EUR", // Austria
  FI: "EUR", // Finland
  IE: "EUR", // Ireland
  PT: "EUR", // Portugal
  BD: "USD", // Portugal
};
// Default currency for unsupported countries
const defaultCurrency = "USD";

// Helper function to get currency symbol
function getCurrencySymbol(currency: string): string {
  const symbols: { [key: string]: string } = {
    INR: "₹",
    USD: "$",
    EUR: "€",
    GBP: "£",
  };
  return symbols[currency] || "$"; // Default to "$" if symbol is not found
}

export type TUCDT = { symbols: string; currency: string; country: string };

export const usePricingFormula = () => {
  const [ucdT, setUCDT] = useState<TUCDT | null>(null);
  const { userData, isUserLoading } = useGlobalContext();

  const computeCurrency = (countryCode: string | undefined): TUCDT => {
    const code = countryCode || "US";
    const currency = countryToCurrency[code] || defaultCurrency;
    const symbol = getCurrencySymbol(currency);
    return { country: code, currency, symbols: symbol };
  };

  const fetchAndSaveCountry = async () => {
    try {
      const { data } = await axios.get(
        `https://ipinfo.io/json?token=${
          import.meta.env.VITE_PUBLIC_IPINFO_TOKEN
        }`
      );
      const detectedCode = data?.country || "US";

      // Update local state for UI
      setUCDT(computeCurrency(detectedCode));

      // Persist to DB (safe way)
      await apiClient.patch("/client-details/me/country", {
        countryCode: detectedCode,
      });
    } catch (err) {
      console.error("Failed to fetch country from ipinfo:", err);
    }
  };

  useEffect(() => {
    if (isUserLoading) return;
    if (userData?.countryCode) {
      console.log("1");
      // Already have country from DB
      setUCDT(computeCurrency(userData.countryCode));
      return;
    } else {
      console.log("2");
      // Fallback to IP-based detection
      fetchAndSaveCountry();
      return;
    }
  }, [userData?.countryCode]);
  return { ucdT: ucdT as TUCDT };
};
